import gql from 'graphql-tag';

export default gql`
  query vendorDashboardQuery($filter: DashboardFilter) {
    dashboards {
      vendors(filter: $filter) {
        total {
          name
          total
          rejected
          overflow
          sold
          unsold
          leadPrice
          totalLeadPrice
          vendorPrice
          totalVendorPrice
        }
        items {
          name
          total
          rejected
          overflow
          sold
          unsold
          leadPrice
          totalLeadPrice
          vendorPrice
          totalVendorPrice
        }
      }
    }
  }
`;
